
import React from 'react';
import { Modal } from "./modal";

/**
 * React element wrapping an invisible file input dialog.
 */
class FileChooser extends React.Component {

  onFileInputChange = e => {
    if (this.props.onChange) {
      this.props.onChange(e.target.files.item(0));
    }
  };

  inputElement = null;

  show = () => {
    this.inputElement.value = "";
    this.inputElement.click();
    document.body.onfocus = this.checkFocus;
  };


  checkFocus = () => {
    if (!this.inputElement) {
      return;
    }
    if (this.inputElement.value.length === 0
      && this.props.onChange) {
      this.props.onChange();
    }
  }

  render = () => {
    const fileStyle = {
      display: "none"
    };

    return (
      <input
        type='file'
        style={fileStyle}
        ref={elem => this.inputElement = elem}
        onChange={this.onFileInputChange}/>
    );
  }
}

/**
 * Bulma styled dialog box with a single line and a
 * button for opening a file chooser.
 */
class FileUploadDialog extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      file: null
    }
  }

  onClose = () => {
    this.props.onEdit();
  };

  onEdit = () => {
    this.props.onEdit(this.state.file);
  };

  onInputChange = (event) => {
    this.setState({file: event.target.value});
  };

  fileChooser = null;
  textInput = null;

  fileButton = () => {
    this.fileChooser.show();
  };

  onFileChange = item => {
    this.setState({
      file: item,
    });
    this.textInput.value = item.name;
  };

  render = () => {

    const iconStyle = {
      fontSize: "1.5rem"
    };

    return (<Modal
      show={true}
      title={this.props.title}
      onDismiss={this.onClose}
      onAction={this.onEdit}
      actionText={this.props.actionText}
    >
      <div className="field is-grouped">
        <p className="control is-expanded">
          <input
            className="input"
            type="text"
            onChange={this.onInputChange}
            ref={elem => this.textInput = elem}
          />
        </p>
        <p className="control">
          <a className="button is-info" onClick={this.fileButton}>
            <span className="icon">
              <FileChooser
                ref={elem => this.fileChooser = elem}
                onChange={this.onFileChange}/>
              <i className="far fa-file-image" style={iconStyle}> </i>
            </span>
          </a>
        </p>
      </div>
    </Modal>);
  };

}

export { FileChooser, FileUploadDialog };